// Generate unique registration code for team member sign up
export const generateRegistrationCode = (): string => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // Removed confusing chars like O,0,I,1
  let code = '';
  for (let i = 0; i < 8; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};

// Format code for display (e.g., XXXX-XXXX)
export const formatRegistrationCode = (code: string): string => {
  if (code.length === 8) {
    return `${code.substring(0, 4)}-${code.substring(4)}`;
  }
  return code;
};

// Parse code from formatted input
export const parseRegistrationCode = (input: string): string => {
  return input.replace(/[-\s]/g, '').toUpperCase();
};
